export const isMuscleblazeBrandReducer = (state = null, action) =>{
    if(action.type === "IS_MUSCLEBLAZE_BRAND"){
        return action.payload
    }
    return state;
}